module.exports = __webpack_public_path__ + "img/tzl.edd78fec.jpg";